import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const REVEAL_SELECTOR = [
  'main.App-content section:not(.home-carousel)',
  'main.App-content [data-scroll-reveal]',
].join(',');

const ScrollReveal = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const observed = new WeakSet();

    const observer = reducedMotion
      ? null
      : new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-revealed', entry.isIntersecting);
          });
        }, { threshold: 0.08, rootMargin: '6% 0px 6% 0px' });

    const prepare = (root = document) => {
      root.querySelectorAll?.(REVEAL_SELECTOR).forEach((element, index) => {
        if (observed.has(element)) return;
        observed.add(element);
        element.classList.add('scroll-reveal');
        element.style.setProperty('--reveal-order', String(index % 4));

        const bounds = element.getBoundingClientRect();
        const alreadyVisible = bounds.top < window.innerHeight * 0.94 && bounds.bottom > 0;
        if (reducedMotion) {
          element.classList.add('is-revealed');
        } else {
          element.classList.toggle('is-revealed', alreadyVisible);
          observer.observe(element);
        }
      });
    };

    prepare();
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) prepare(node.parentElement || node);
        });
      });
    });

    const content = document.querySelector('main.App-content');
    if (content) mutationObserver.observe(content, { childList: true, subtree: true });

    return () => {
      mutationObserver.disconnect();
      observer?.disconnect();
    };
  }, [pathname]);

  return null;
};

export default ScrollReveal;
